define(function (require) {
    'use strict';

    var jQuery = require('jquery');

    (function ($, window, document, undefined) {

        var pluginName = 'inputcursor';

        var methods = {

            setSelection:function (selectionStart, selectionEnd) {

                if (this.length === 0) {
                    return this;
                }
                var input = this[0];
                if (input.createTextRange) {
                    var range = input.createTextRange();
                    range.collapse(true);
                    range.moveEnd('character', selectionEnd);
                    range.moveStart('character', selectionStart);
                    range.select();
                } else if (input.setSelectionRange) {
                    input.focus();
                    input.setSelectionRange(selectionStart, selectionEnd);
                }
                return this;
            },

            setCursorPosition:function (position) {
                if (this.length === 0) {
                    return this;
                }
                return methods.setSelection.apply(this, [position, position]);
            },

            focusEnd:function () {
                methods.setCursorPosition.apply(this, [this.val().length]);
            },

            focusStart:function () {
                methods.setCursorPosition.apply(this, [0]);
            },

            selectAll:function () {
                methods.setSelection.apply(this, [0, this.val().length]);
            }
        };

        $.fn[pluginName] = function (method) {
            if (methods[method] && !method.match("^_")) {
                return methods[method].apply(this, Array.prototype.slice.call(arguments, 1));
            } else if (typeof method === 'object' || !method) {
                methods.destroy.apply(this);
                return methods.init.apply(this, arguments);
            }

            $.error('Method ' + method + ' does not exist in jquery.' + pluginName);
        };
    })(jQuery, window, document);
});